import { MasterOrderBy } from '@/common/api/modules/master'
import { ListFollowTableHeaderProps, makeRectPropsForTableHeadItem } from '@/common/app/list'
import { MasterType, W2_MASTER_CONFIGS } from '@/common/model/master/w2Master'

import CheckBox from '@/components/view/atoms/checkbox/CheckBox'
import TableHeadItem from '@/components/view/atoms/table/TableHeadItem'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

interface TheadProps extends ListFollowTableHeaderProps {
  masterType: MasterType
  selected: boolean
  allSelected: boolean
  onCheck(checked: boolean): void
  orderBy: MasterOrderBy | null
  onChangeOrderBy(orderBy: MasterOrderBy | null): void
  float?: boolean
}

const MasterListThead = ({
  masterType,
  selected,
  allSelected,
  onCheck,
  orderBy,
  onChangeOrderBy,
  float = false,
  isScrolled,
  rowRefs,
  rowRects
}: TheadProps) => {
  const rectProps = (index: number) =>
    makeRectPropsForTableHeadItem(rowRefs, rowRects, index, float)

  return (
    <>
      <TableHeadItem checkbox sticky={0} float={float} {...rectProps(0)}>
        <CheckBox name={'all'} checked={selected} onChange={onCheck} incomplete={!allSelected} />
      </TableHeadItem>
      {W2_MASTER_CONFIGS[masterType].columns.map((column, index) => (
        <TableHeadItem key={column.key} float={float} {...rectProps(index + 1)}>
          <Text color={TextColor.SECONDARY} size={12}>
            {column.label}
          </Text>
        </TableHeadItem>
      ))}
    </>
  )
}

export default MasterListThead
